import { types } from "../actions/types";

const initialState = {
    initialized: false,
    isAuthenticated: false,
    user: {
        id: 0,
        avatar: '',
        email: '',
        first_name: '',
        last_name: '',
        birthday: '',
        internal_country_code: '',
        pathologies: [],
        allergies: [],
        intolerances: [],
        gender_id: 0,
        token: '',
        refresh_token: '',
        gympass_user_id: '',
        stripe_suscription_id: '',
        created: '',
        restriction_tag: '',
        stripe_suscription_status: '',
        internal_ip: '',
        external_id: null,
        active: 0,
        language_id: 0,
        answer_days: 0,
        answer_equipment: null,
        answer_sport: null,
        answer_motivation: null,
        answer_nutrition: null,
        country_code: '',
        stripe_current_period_end: 0,
        height: 0,
        weight: 0,
        fat: 0,
        nutritional_objective: 0,
        workouts_per_week: 0,
        food_preference_id: null,
        disciplines: [],
        objectives: [],
        body_focuses: [],
        physical_qualities: [],
        lesions: [],
        referer_code: '',
        referer_discount: 0,
        referer_credit: 0,
        modified: '',
        isFromPartner: false,
        partner: null,
        section: null,
        stepper_finished: false,
    },
    nutritionalProfile: {
        height: null,
        weight: null,
        foodPathologies: [],
        foodAllergies: [],
        foodIntolerances: [],
        foodPreference: null,
        workoutsPerWeek: null,
        objective: null,
        fatPercentage: null,
    },
    membership: {},
};


export const authReducer = (state = initialState, action) => {
    switch (action?.type) {

        case types.initialized:
            return {
                ...state,
                initialized: action.payload
            }
        case types.login:
            return {
                isAuthenticated: true,
                user: { ...state.user, ...action.payload.user },
                membership: { ...state.membership, ...action.payload.membership },
                nutritionalProfile: { ...state.nutritionalProfile, ...action.payload.nutritionalProfile },
            };
        case types.logout:
            return {
                initialized: false,
                isAuthenticated: false,
                user: {},
                membership: {},
                nutritionalProfile: {},
                partnerList: [],
                profiles: {}
            };
        case types.updateUser:
            return { ...state, user: { ...state.user, ...action.payload } };
        case types.updateMembership:
            return { ...state, membership: { ...state.membership, ...action.payload } };
        case types.updateNutritionalProfile:
            return { ...state, nutritionalProfile: { ...state.nutritionalProfile, ...action.payload } };
        default:
            return state;
    }
};
